import { render, staticRenderFns } from "./paymentauto.vue?vue&type=template&id=0a7f0a9f"
import script from "./paymentauto.vue?vue&type=script&lang=js"
export * from "./paymentauto.vue?vue&type=script&lang=js"
import style0 from "./paymentauto.vue?vue&type=style&index=0&id=0a7f0a9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports